import { graphql } from "gql";

const HAPPYCO_WORK_ORDERS_QUERY = graphql(`
  query HappycoWorkOrders($happycoIds: [ID!]!) {
    happycoWorkOrders(happycoIds: $happycoIds) {
      ...HappycoWorkOrder
    }
  }
`);

export default HAPPYCO_WORK_ORDERS_QUERY;
